import logo from "../assets/logo.png";
import logoDark from "../assets/logo-dark.png";
import useTheme from "../contexts/ThemeContext";
import { useState } from "react";

export default function Logo({ className }) {
  const [theme, setTheme] = useState(useTheme());
  return (
    <img
      className={className}
      src={useTheme() == "dark" ? logoDark : logo}
      alt="logo"
    />
  );
}
